/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $on = _ref.$on,
      $update = _ref.$update;

  var check = function check() {
    if ($("#PayLot").val() > localStorage.getItem("account-own-lots") || $("#PayLot").val() <= 0) {
      $f7.dialog.alert("Please enter correct amount of Lots in between 0.01 to " + localStorage.getItem("account-own-lots"));
      return;
    }

    if ($("#PayAmountUSD").val() < 10) {
      $f7.dialog.alert("Withdraw must above USD 10");
      return;
    }

    requestOTP();
  };

  var requestOTP = function requestOTP() {
    $f7.request({
      method: 'get',
      url: window.path + 'static/api/otp_email.php',
      data: {
        email: localStorage.getItem("Email")
      },
      success: function success(data) {
        console.log("Output:" + data);
        data = JSON.parse(data);
        $f7.dialog.prompt('An OTP is sent to your email. Please enter the OTP number', function (TAC) {
          if (TAC == data.otp) {
            pay();
          } else {
            $f7.dialog.alert("Wrong OTP number please try again");
          }
        });
      },
      error: function error(e) {
        $f7.dialog.alert(e);
      }
    });
  };

  var pay = function pay() {
    $f7.dialog.confirm('Are you sure you want to withdraw?', function () {
      $f7.request({
        method: 'get',
        url: window.path + 'static/api/bill.php?action=withdraw',
        data: {
          Name: localStorage.getItem("Name"),
          Phone: localStorage.getItem("Phone"),
          Email: localStorage.getItem("Email"),
          Amount: $("#PayAmount").val(),
          AmountUSD: $("#PayAmountUSD").val(),
          Lots: $("#PayLot").val(),
          AccountNumber: localStorage.getItem("AccountNumber")
        },
        success: function success(data) {
          $f7.dialog.alert("Withdraw has been requested");
          $f7.views.current.router.navigate("/transaction/");
        },
        error: function error(e) {
          $f7.dialog.alert(e);
        }
      });
    });
  };

  $on('pageInit', function () {
    $("#SellName").val(localStorage.getItem("Name"));
    $("#SellBankName").val(localStorage.getItem("BankName") + " - " + localStorage.getItem("BankAccount"));
    $("#SellBankAccount").val(localStorage.getItem("BankAccount"));
    $(".SellLots").html(localStorage.getItem("account-own-lots"));
    $("#PayLot").val(localStorage.getItem("account-own-lots"));
    $("#PayAmount").val((localStorage.getItem("account-stock-price") * $("#PayLot").val() * window.rate).toFixed(2));
    $("#PayAmountUSD").val((localStorage.getItem("account-stock-price") * $("#PayLot").val()).toFixed(2));
    $("#PayLot").on('change keydown paste input', function () {
      //console.log("something");
      $("#PayAmount").val((localStorage.getItem("account-stock-price") * $("#PayLot").val() * window.rate).toFixed(2));
      $("#PayAmountUSD").val((localStorage.getItem("account-stock-price") * $("#PayLot").val()).toFixed(2));
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">Withdraw</div>
    </div>
  </div>
  <div class="page-content" style="background: linear-gradient(45deg, #121212 0%, #121212 100%);">
    
    <div class="card card-update" style="border-radius: 10px;background-color: #151924;">
      <div class="card-header">
        <div class="row">
          <div class="col-20"><img src="static/images/information.png" style="width: 100%"/></div>
          <div class="col-80">Note</div>
        </div>
      </div>
      <div class="card-content card-content-padding">
        Please be informed that as part of our standard processing procedures, you can anticipate receiving the funds, with a <span class="makeitbold">minimum amount</span> of <span class="makeitbold">USD 10</span>, within a period of <span class="makeitbold">3 working days</span> from the date of your request or transaction initiation.
      </div>
    </div>

    <div class="card card-update" style="border-radius: 10px;background-color: #151924;">
      <!-- <div class="card-header">Receiver
      </div> -->
      <div class="card-content card-content-padding">
        <div class="list no-hairlines-md">
          <ul>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Transfer to</div>
                  <div class="item-input-wrap">
                    <input type="text"  id='SellName' placeholder="Your name" disabled style="color: gray;"/>
                    <input type="text" id='SellBankName' placeholder="" disabled style="color: gray;"/>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card card-update" style="border-radius: 10px;background-color: #151924;">
      <div class="card-content card-content-padding">
        <div class="list no-hairlines-md">
          <ul>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Total Lot (0.01 to <span class="SellLots"></span>)</div>
                  <div class="item-input-wrap">
                    <input type="number" id='PayLot' placeholder="0.01 to 100" value="0.01"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Amount To Receive (USD)</div>
                  <div class="item-input-wrap">
                    <input type="number" id='PayAmountUSD' disabled style="color: gray;"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Amount To Receive (MYR)</div>
                  <div class="item-input-wrap">
                    <input type="number" id='PayAmount' disabled style="color: gray;"/>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <button class="button button-fill" @click="${check}">WITHDRAW</button>
      
    </div>

    
  </div>
</div>
`
    }
    ;
}

framework7Component.id = '074d545ecd';
export default framework7Component;